import { FETCH_ALL_PENDING_USER_LIST_FAILED, FETCH_ALL_PENDING_USER_LIST_PENDING, FETCH_ALL_PENDING_USER_LIST_SUCCESS } from "../types";

const initialState = {
    allPendingUsersDataStatus: '',
    allPendingUsersData: {},
};
const UsersReducer = (state = initialState, action = '') => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ALL_PENDING_USER_LIST_PENDING:
            return {
                ...state,
                allPendingUsersDataStatus: 'PENDING',
                allPendingUsersData: []
            };
        case FETCH_ALL_PENDING_USER_LIST_SUCCESS:
            return {
                ...state,
                allPendingUsersDataStatus: 'SUCCESS',
                allPendingUsersData: payload
            };
        case FETCH_ALL_PENDING_USER_LIST_FAILED:
            return {
                ...state,
                allPendingUsersDataStatus: 'FAILED',
                allPendingUsersData: []
            };
        default:
            return state;
    }
}
export default UsersReducer;

